import { Spacer, TextSubtitle } from '@pypestream/design-system';
import {
  TranslationComponent,
  TranslationKeys,
} from '@pypestream/translations';
import { type FC } from 'react';
import { PuffLoader } from 'react-spinners';

export const Loader: FC<{
  relative?: boolean;
  i18nKey?: string;
  progress?: string | number;
}> = ({ relative, i18nKey = 'pro-studio/common:loading', progress }) => (
  <div
    className={relative ? '' : 'u-full-width u-full-height u-overflow-hidden'}
    style={{
      minHeight: relative ? '100%' : 'calc(100vh - 60px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    }}
  >
    <PuffLoader color="#5956E3" size={60} speedMultiplier={2} />
    <Spacer size="small" />
    <TextSubtitle>
      <TranslationComponent i18nKey={i18nKey as TranslationKeys}>
        Loading
      </TranslationComponent>
      {progress ? `: ${progress}%` : '...'}
    </TextSubtitle>
  </div>
);
